﻿import {
  AUTHORIZE_PAGE,
  SHOW_OVERLAY,
  UPDATE_CONFIG, UPDATE_IMAGE_QUEUE_PATIENT_STATUS,
  UPDATE_ME,
  UPDATE_PAGE,
  UPDATE_PATIENT,
  UPDATE_SETTINGS,
  UPDATE_SYSTEM_SETTINGS,
  VERIFY_DISABLED
} from './types.js';

export const disableVerify = () => dispatch => {
  dispatch({ type: VERIFY_DISABLED, disabled: true });
};

export const enableVerify = () => dispatch => {
  dispatch({ type: VERIFY_DISABLED, disabled: false });
};

export const showOverlay = () => dispatch => {
  dispatch({ type: SHOW_OVERLAY, show: true });
};

export const hideOverlay = () => dispatch => {
  dispatch({ type: SHOW_OVERLAY, show: false });
};

export const updateConfig = config => dispatch => {
  dispatch({
    type: UPDATE_CONFIG,
    config
  });
};

export const updateMe = me => dispatch => {
  dispatch({
    type: UPDATE_ME,
    me
  });
};

export const updateSettings = settings => dispatch => {
  dispatch({
    type: UPDATE_SETTINGS,
    settings
  });
};

export const updateImageQueuePatientStatus = imageQueuePatientStatus => dispatch => {
  dispatch({
    type: UPDATE_IMAGE_QUEUE_PATIENT_STATUS,
    imageQueuePatientStatus
  });
};

export const updatePatient = patient => dispatch => {
  dispatch({
    type: UPDATE_PATIENT,
    patient
  });
};

export const updateSystemSettings = systemSettings => dispatch => {
  dispatch({
    type: UPDATE_SYSTEM_SETTINGS,
    systemSettings
  });
};

export const navigate = (page, loadFile, params, query, requiresAuth) => dispatch => {
  loadFile();

  dispatch({
    type: UPDATE_PAGE,
    page,
    params,
    query,
    requiresAuth
  });
};

export const authorize = (page, granted) => dispatch => {
  dispatch({
    type: AUTHORIZE_PAGE,
    page,
    granted
  });
};
